import axios from "axios";
import { getRequest, postRequest } from "../libs/AxiosService.util";
import Constants from "../config/constants";

export const STAFF_TYPE = {
  ADMIN: "ADMIN",
  LEAD: "LEAD",
  TELECALLER: "TELECALLER",
};

export const EMPLOYEE_TYPE = {
  INTERNAL: "INTERNAL",
  TELEPERFORMANCE: "TELEPERFORMANCE",
};

export const EMPLOYEE_TYPE_LABELS = {
  [EMPLOYEE_TYPE.INTERNAL]: "Internal",
  [EMPLOYEE_TYPE.TELEPERFORMANCE]: "Teleperformance",
};

export async function serviceGetStaffList(params) {
  return await postRequest("admins", params);
}

/**
 * Streams the employee CSV export from the backend and triggers a browser download.
 * Uses axios responseType=blob so the stream is consumed without loading JSON parsing.
 * The Authorization header is already attached via axios defaults (see libs/set_auth_token.utils).
 */
export async function serviceExportStaff(params = {}) {
  try {
    const response = await axios.post(
      `${Constants.DEFAULT_APP_URL}admins/export`,
      { ...params },
      { responseType: "blob" }
    );
    const contentType = response?.headers?.["content-type"] || "";
    if (!contentType.includes("text/csv")) {
      return { error: true, message: "Export failed" };
    }
    const disposition = response?.headers?.["content-disposition"] || "";
    const match = /filename="?([^"]+)"?/i.exec(disposition);
    const filename = match?.[1] || `employees_${Date.now()}.csv`;
    const blob = new Blob([response.data], { type: "text/csv;charset=utf-8" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => window.URL.revokeObjectURL(url), 1000);
    return { error: false };
  } catch (err) {
    return {
      error: true,
      message: err?.response?.data?.response_message || "Export failed",
    };
  }
}
export async function serviceCreateStaff(params) {
  return await postRequest("admins/create", params);
}
export async function serviceUpdateStaff(params) {
  return await postRequest("admins/update", params);
}
export async function serviceGetStaffDetails(params) {
  return await postRequest("admins/details", params);
}
export async function serviceDeleteStaff(params) {
  return await postRequest("admins/delete", params);
}
export async function serviceGetTeamByManager(params) {
  return await postRequest("admins/team-by-manager", params);
}

/** Check if email already exists (for admin users / employees). Pass id on update to exclude current user. */
export async function serviceCheckEmailExists(email, id = null) {
  return await postRequest("admins/check-email", { email: email || undefined, id: id || undefined });
}

/** Check if employee_id already exists. Pass id on update to exclude current user. */
export async function serviceCheckEmployeeIdExists(employee_id, id = null) {
  return await postRequest("admins/check-employee-id", { employee_id: employee_id || undefined, id: id || undefined });
}

export async function serviceGetAdminUser(params) {
  return await postRequest("doctors/professionals/list", params);
}
export async function serviceGetAdminUserDetail(params) {
  return await postRequest("doctors/professional/details", params);
}
export async function serviceGetAdminUserCalendarDetail(params) {
  return await postRequest("doctors/available-days", params);
}
export async function serviceExportAdminUser(params) {
  return await postRequest("doctors/professionals/list/export", params);
}
export async function serviceGetAdminUserList(list, otherParams = {}) {
    return await postRequest('list', { list: list, ...otherParams, });
}
export async function serviceCreateDoctorAvailabilty(params) {
    return await postRequest('doctors/create-availability',params);
}
export async function serviceGetConfigSlotDoctor(params) {
  return await getRequest("doctors/slots/config", params);
}
export async function serviceDoctorAvailabilty(params) {
    return await postRequest('doctors/availability',params);
}
export async function serviceDoctorAvailabilityByDoctors(params) {
    return await postRequest('doctors/availability/by/doctors',params);
}
export async function serviceCreateAdminUser(params) {
    return await postRequest('doctors/create/professional', params);
}
export async function serviceGetCommonSalesEmployee(params) {
  return await postRequest("list", params);
}
export async function serviceExportDoctorAvailability(params) {
  return await postRequest("doctors/availability/by/doctors/export");
}

export async function serviceGetDoctorWalletLedgers(params) {
  return await postRequest("doctors/wallet/ledger", params);
}

